module.exports = __webpack_public_path__ + "assets/img/ic-recovery-hover.6fb900f2.svg";